class CartConfetti {
  constructor(canvasSelector = '#cart-confetti-canvas') {
    this.canvasSelector = canvasSelector;
    this.particles = [];
    this.animationId = null;
    this.colors = ['#866044', '#c9a15f', '#f2e1c4', '#d4af37', '#e8c874'];
    this.flowers = ['🌸', '🌼', '🌺', '✨'];
  }

  getCanvas() {
    return document.querySelector(this.canvasSelector);
  }

  resize(canvas) {
    const container = canvas.closest('.drawer__inner') || canvas.parentElement;
    const rect = container.getBoundingClientRect();

    if (rect.width > 0 && rect.height > 0) {
      canvas.width = rect.width;
      canvas.height = rect.height;
      return true;
    }

    // Fallback: container not sized yet (mobile mid-transition) — use viewport
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    return false;
  }

  createParticle(canvas, type) {
    return {
      type,
      x: Math.random() * canvas.width,
      y: -20 - Math.random() * canvas.height * 0.3,
      size: type === 'flower' ? 14 + Math.random() * 12 : 6 + Math.random() * 6,
      speedY: 2 + Math.random() * 3,
      speedX: (Math.random() - 0.5) * 2,
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 8,
      color: this.colors[Math.floor(Math.random() * this.colors.length)],
      emoji: this.flowers[Math.floor(Math.random() * this.flowers.length)],
      opacity: 1,
      wobble: Math.random() * Math.PI * 2,
    };
  }

  launch() {
    const canvas = this.getCanvas();
    if (!canvas) return;

    const sized = this.resize(canvas);
    if (!sized) {
      // container not visible/sized yet — wait a tick and retry once
      requestAnimationFrame(() => {
        this.resize(canvas);
        this._start(canvas);
      });
      return;
    }

    this._start(canvas);
  }

  _start(canvas) {
    canvas.style.display = 'block';
    const ctx = canvas.getContext('2d');
    this.particles = [];

    const total = 70;
    for (let i = 0; i < total; i++) {
      const type = Math.random() < 0.35 ? 'flower' : 'confetti';
      this.particles.push(this.createParticle(canvas, type));
    }

    if (this.animationId) cancelAnimationFrame(this.animationId);

    const startTime = performance.now();
    const duration = 3200;

    const animate = (now) => {
      const elapsed = now - startTime;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      this.particles.forEach((p) => {
        p.wobble += 0.08;
        p.x += p.speedX + Math.sin(p.wobble) * 0.6;
        p.y += p.speedY;
        p.rotation += p.rotationSpeed;

        if (elapsed > duration - 600) {
          p.opacity = Math.max(0, 1 - (elapsed - (duration - 600)) / 600);
        }

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = p.opacity;

        if (p.type === 'flower') {
          ctx.font = `${p.size}px serif`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(p.emoji, 0, 0);
        } else {
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        }

        ctx.restore();
      });

      if (elapsed < duration) {
        this.animationId = requestAnimationFrame(animate);
      } else {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.style.display = 'none';
        this.animationId = null;
      }
    };

    this.animationId = requestAnimationFrame(animate);
  }
}

window.cartConfetti = window.cartConfetti || new CartConfetti();